//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Typography from "@material-ui/core/Typography";

const AuditorWelcomeOverview = ({ path }) => {
  return (
    <React.Fragment>
      <Typography component="div" variant="body2" color="textSecondary">
        <h2>About the P6-Auditor</h2>

        <h3>
          Display information from Primavera P6 audit tables in a user-friendly
          format
        </h3>
        <p>
          Take better control of your P6 EPPM database Have the ability to
          effectively report on the changes to your database and the activity of
          all of your users Get data from database level records in easy-to-use
          pre-built reports for auditing, usage, licenses, etc.
        </p>
      </Typography>
    </React.Fragment>
  );
};
export default AuditorWelcomeOverview;
